<template>
  <div class="print-container" id="pdfDom">
    <div class="top-dev" :style="{ height: devlTop ? '841.89px' : 'auto' }">
      <div class="container-title">
        {{ $t('page_ops_priht_pdf_work_record_No') }}{{ detail.code }}
      </div>
      <div>
        <table class="table-left">
          <tr>
            <td>{{ $t('page_ops_customer_customer_name') }}：{{ detail.customerName }}</td>
            <td>
              {{ $t('page_ops_priht_pdf_processing_progress') }}：{{ detail.processProgress }}
            </td>
          </tr>
          <tr>
            <td>{{ $t('page_extranet_Machine_serial_number') }}：{{ detail.workStationCode }}</td>
            <td>{{ $t('page_ops_machine_machine_name') }}：{{ detail.workStationName }}</td>
          </tr>
          <tr>
            <td>{{ $t('page_ops_work_record_job_classification') }}：{{ detail.jobTypeName }}</td>
            <td>{{ $t('page_ops_work_record_industry_classification') }}：{{ detail.industryTypeName }}</td>
          </tr>
          <tr>
            <td>{{ $t('page_ops_work_record_reporter') }}：{{ detail.contactUserName }}</td>
            <td>{{ $t('page_ops_priht_pdf_contact_information') }}：{{ detail.contactInfo }}</td>
          </tr>
          <tr>
            <td>{{ $t('page_ops_priht_pdf_submitter') }}：{{ detail.submitUserName }}</td>
            <td v-if="detail.customerAddress.provinceName !== detail.customerAddress.cityName">
              {{ $t('page_ops_work_record_customer_address') }}：
              {{ detail.customerAddress.provinceName }}{{ detail.customerAddress.cityName }}{{ detail.customerAddress.address }}
            </td>
            <td v-else>
              {{ $t('page_ops_work_record_customer_address') }}：
              {{ detail.customerAddress.cityName }}{{ detail.customerAddress.address }}
            </td>
          </tr>
          <tr>
            <td>{{ $t('page_ops_customer_email') }}：{{ detail.email }}</td>
            <td>{{ $t('page_ops_customer_wx_account') }}：{{ detail.wxAccount }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="container-title">{{ $t('page_ops_priht_pdf_request_details') }}</div>
    <div class="container-detail">
      <div class="container-question">
        <div>{{ $t('page_ops_priht_pdf_customer_request') }}：</div>
        <div>{{ detail.questionDescription }}</div>
      </div>
      <div class="container-question">
        <div>{{ $t('page_ops_work_record_component_request') }}：</div>
        <div>{{ detail.componentDescription }}</div>
      </div>
    </div>
    <div
      class="addKOng2"
      :style="{ height: detailTop ? 841.89 - devlHei - detailHei + 'px' : 0 }"
    ></div>
    <div class="addKOng3" :style="{ height: imgTop ? 841.89 - detailHei + 'px' : 0 }"></div>
    <div class="container-imgvideo">
      <div>{{ $t('page_ops_priht_pdf_photos_videos') }}：</div>
      <div class="img-list">
        <span v-for="(pic, i) in imglist" :key="i" class="pic-con">
          <img :src="pic ? pic : ''" />
        </span>
      </div>
    </div>
    <div class="addKOng4" :style="{ height: bothTop ? 841.89 - imgHei - 20 + 'px' : 0 }"></div>
    <div class="addKOng5" :style="{ height: allTop ? 841.89 - imgHei - devlHei - detailHei - 132 + 'px' : 0 }"></div>
    <div class="container-title" :style="{ marginTop: bothTop ? '10px' : (allTop ? 841.89 - (devlHei + detailHei + imgHei + 55) + 'px' : '0') }" >{{ $t('page_ops_priht_pdf_processing_record') }}</div>
    <template v-for="(res, ind) in list">
      <div v-if="res && res.length" :key="ind" :style="{ marginTop: ind >= 1 ? '100px' : '0' }">
        <table>
          <tr>
            <td>{{ $t('page_ops_priht_pdf_processing_node') }}</td>
            <td>{{ $t('page_ops_priht_pdf_handler') }}</td>
            <td>{{ $t('page_ops_priht_pdf_processing_time') }}</td>
            <td>{{ $t('page_ops_priht_pdf_details') }}</td>
          </tr>
          <tr :key="index" v-for="(item, index) in res">
            <td>{{ item.processStepName }}</td>
            <td>{{ item.processUserName }}</td>
            <td>
              {{ dayTime(item.processTime) }}
            </td>
            <td>{{ item.processComment }}</td>
          </tr>
          <template v-if="(ind >= 1 || allTop) && res && res.length < 12">
            <tr :key="index" v-for="(item, index) in (12 - res.length)">
              <td style="color: transparent;"> {{ index }} </td>
              <td style="color: transparent;"> {{ index }} </td>
              <td style="color: transparent;"> {{ dayTime(new Date()) }} </td>
              <td style="color: transparent;"> {{ index }} </td>
            </tr>
          </template>
        </table>
      </div>
    </template>
    <div :style="{marginTop: list && list.length > 1 ? '20px' : (allTop ? '10px' : '0')}"></div>
    <template v-for="(pic, i) in imglist">
      <span :key="i" class="pic-conview">
        <img :src="pic ? pic : ''" />
      </span>
    </template>
    <div class="cover" v-if="loading">
      <a-spin size="large" tip="数据正在加载中..."> </a-spin>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import dayjs from 'dayjs'
import { stubTrue } from 'lodash'

export default {
  computed: {
    ...mapGetters(['workHistoryPrintData']),
    workList() {
      return this.workHistoryPrintData.workRecordProcessCommentList
    },
    detail() {
      return this.workHistoryPrintData.workRecordDetailVO
    },
    devlTop() {
      return this.detailHei + this.devlHei + 80 > 841.89
    },
    detailTop() {
      return (
        this.detailHei + this.devlHei + 80 < 841.89 &&
        this.detailHei + this.devlHei + this.imgHei + 80 > 841.89
      )
    },
    imgTop() {
      const set1 = this.devlHei + this.detailHei + this.imgHei + 80 > 841.89
      const set2 = this.devlHei + this.detailHei + 80 > 841.89
      const set3 = this.detailHei + this.imgHei + 80 > 841.89
      console.log(set1, set2, set3, 'set')
      return (
        this.devlHei + this.detailHei + this.imgHei + 80 > 841.89 &&
        this.devlHei + this.detailHei + 80 > 841.89 &&
        this.detailHei + this.imgHei + 80 > 841.89
      )
    },
    bothTop() {
      return this.devlHei + this.detailHei + this.imgHei + 80 > 841.89
    },
    allTop() {
      if(this.list && this.list.length){
        const listH = this.list[0]
        return this.devlHei + this.detailHei + this.imgHei + 80 + 60 + (listH && listH.length ? listH.length * 65 : 0) > 841.89
      } else {
        return false
      }
    }
  },
  data() {
    return {
      devlHei: 0,
      detailHei: 0,
      imgHei: 0,
      list: [],
      imglist: [],
      loading: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.mathsHeight()
    }, 1000)
  },
  created() {
    this.imgUrl()
  },
  methods: {
    imgUrl() {
      this.imglist = []
      const url = this.workHistoryPrintData.workRecordDetailVO.attachList
      if (url && url.length) {
        url.forEach((res) => {
          this.function(res)
        })
      }
    },
    mathsHeight() {
      const devl = document.querySelector('.top-dev') // 详情Dom
      const detail = document.querySelector('.container-detail') // 客户请求Dom
      const img = document.querySelector('.container-imgvideo') // 图片Dom

      this.devlHei = devl.clientHeight
      this.detailHei = detail.clientHeight + 60
      this.imgHei = img.clientHeight
      this.list = []
      const workLista = this.workHistoryPrintData.workRecordProcessCommentList
      if (this.devlHei + this.detailHei + this.imgHei + 80 < 841.89) {
        const aa = 841.89 - this.devlHei - this.detailHei - this.imgHei - 80 - 60
        const num = Math.floor(aa / 65)
        this.addList(workLista, num)
      } else {
        if (this.devlHei + this.detailHei + 80 < 841.89) {
          const aa = 841.89 - this.imgHei - 80
          const num = Math.floor(aa / 65)
          this.addList(workLista, num)
        } else {
          if (this.detailHei + this.imgHei + 120 < 841.89) {
            const aa = 841.89 - this.detailHei - this.imgHei - 80
            const num = Math.floor(aa / 65)
            this.addList(workLista, num)
          } else {
            const aa = 841.89 - this.imgHei - 80
            const num = Math.floor(aa / 65)
            this.addList(workLista, num)
          }
        }
      }
      this.loading = false
      setTimeout(() => {
        this.getPdf()
      }, 1000)
    },
    addList(workLista, num) {
      let loseList = []
      if (num > 0) {
        const numfirst = workLista.slice(0, num)
        this.list.push(numfirst)
        loseList = workLista.filter((res, index) => index >= num)
      } else {
        loseList = workLista
      }
      if (loseList.length > 12) {
        let start = 0
        let end = 12
        const forI = Math.floor(loseList.length / 12)
        for (let i = 0; i <= forI; i++) {
          const numfor = loseList.slice(start, end)
          this.list.push(numfor)
          start += 12
          end += 12
        }
      } else {
        this.list.push(loseList)
      }
    },

    function(url) {
      this.getBase64(url).then((res) => {
        this.imglist.push(res)
      })
    },

    //实现将项目的图片转化成base64
    getBase64(img) {
      function getBase64Image(imgw) {
        var canvas = document.createElement('canvas')
        canvas.width = imgw.width
        canvas.height = imgw.height
        var ctx = canvas.getContext('2d')
        ctx.drawImage(imgw, 0, 0, imgw.width, imgw.height)
        var dataURL = canvas.toDataURL('image/png')
        // console.log(dataURL)
        return dataURL
      }
      return new Promise((resolve, reject) => {
        var image = new Image()
        image.setAttribute('crossOrigin', 'anonymous')
        image.crossOrigin = '*'
        image.src = img + '?v=' + Math.random()
        image.onload = () => {
          resolve(getBase64Image(image)) //将base64传给done上传处理
        }
      })
    },
    dayTime(time) {
      return time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    getPdf() {
      let title = this.detail.code
      let opts = {
        scale: 5,
        // canvas: c,
        allowTaint: true,
        useCORS: true,
        logging: stubTrue
      }
      html2Canvas(document.querySelector('#pdfDom'), opts).then(function(canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = (contentWidth / 592.28) * 841.89
        let leftHeight = contentHeight
        // console.log(leftHeight, pageHeight)
        let position = 0
        let imgWidth = 595.28
        let imgHeight = (592.28 / contentWidth) * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
        setTimeout(() => {
          // window.close()
        }, 100)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.print-container {
  width: 595.28px;
  // margin: 64px 0;
  padding: 40px 16px 0;
  .cover {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #fff;
    z-index: 9999999999999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .container-title {
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    padding: 16px 0;
  }
  .table-left {
    tr {
      td {
        min-width: 180px;
        padding: 8px;
        text-align: left;
      }
    }
  }
  .img-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: space-evenly;
    span {
      width: 25%;
      margin: 0 4px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .container-detail {
    border: 1px solid #000;
    width: 100%;
    font-size: 14px;
    color: #000;
    .container-question {
      border-bottom: 1px solid #000;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 8px;
    }
  }
  .container-imgvideo {
    border: 1px solid #000;
    width: 100%;
    font-size: 14px;
    color: #000;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 8px;
  }
  .pic-conview{
    width: 100%;
    display: inline-block;
    padding-top: 20px;
    height: 841.89px;
    border: 1px solid transparent;
    margin-bottom: 6px;
    img{
      width: 100%;
      height: auto;
      max-height: calc(100% - 20px);
    }
  }
  .pic-conview:last-child{
    margin-bottom: 0;
  }
  table {
    width: 100%;
    font-size: 14px;
    border: 1px solid #000;
    // font-weight: 700;
    tbody {
      width: 100%;
    }
    tr {
      td {
        min-width: 110px;
        padding: 8px;
        text-align: center;
        color: #000;
        border: 1px solid #000;
        overflow-wrap: break-word;
        &:nth-child(1),
        &:nth-child(2) {
          width: 110px;
          max-width: 110px;
        }
        &:nth-child(3) {
          width: 110px;
          max-width: 110px;
        }
        &:nth-child(4) {
          width: 229px;
          max-width: 229px;
        }
      }
    }
  }
}
</style>
